import { FC } from 'react';

import { AsyncSearch, Loader } from 'components';
import { searchTruckingCompanies } from 'services';
import { Transaction, TruckingCompany } from 'types';
import { useEditTransaction } from './edit-transaction.context';

const EditTrucking: FC = () => {
  const { transaction, setTransaction } = useEditTransaction();

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>TRUCKING DETAILS</h4>
      </div>
      <div className="card-body">
        <Loader loading={transaction === undefined}>
          <div className="grid-5 p-2">
            <div>
              <h6 className="text-info-dark">COMPANY (SCAC)</h6>
              <div className="mt-2 w-100">
                <AsyncSearch<TruckingCompany>
                  required
                  value={transaction?.truckingCompany}
                  formatOption={({ name, scacCode }) => `${name} (${scacCode})`}
                  formatValue={truckingCompany => truckingCompany?.scacCode ?? ''}
                  handleSelect={truckingCompany => setTransaction(t => t && ({ ...t, truckingCompany } as Transaction))}
                  search={searchTruckingCompanies}
                  data-cy="edit-transaction-trucking-company-search"
                />
              </div>
            </div>
            <div>
              <h6 className="text-info-dark">TRUCK NUMBER</h6>
              <input
                type="text"
                className="mt-2 w-100"
                value={transaction?.truckNumber ?? ''}
                onChange={e => setTransaction(t => t && { ...t, truckNumber: e.target.value })}
                data-cy="edit-transaction-truck-number-input"
              />
            </div>
            <div>
              <h6 className="text-info-dark">DRIVER NAME</h6>
              <input
                type="text"
                className="mt-2 w-100"
                value={transaction?.driverName ?? ''}
                onChange={e => setTransaction(t => t && { ...t, driverName: e.target.value })}
                data-cy="edit-transaction-driver-name-input"
              />
            </div>
            <div>
              <h6 className="text-info-dark">CDL NUMBER</h6>
              <input
                type="text"
                className="mt-2 w-100"
                value={transaction?.cdlNumber ?? ''}
                onChange={e => setTransaction(t => t && { ...t, cdlNumber: e.target.value })}
                data-cy="edit-transaction-cdl-number-input"
              />
            </div>
            <div>
              <h6 className="text-info-dark">LICENSE PLATE</h6>
              <input
                type="text"
                className="mt-2 w-100"
                value={transaction?.licensePlate ?? ''}
                onChange={e => setTransaction(t => t && { ...t, licensePlate: e.target.value })}
                data-cy="edit-transaction-license-plate-input"
              />
            </div>
          </div>
        </Loader>
      </div>
    </div>
  );
};

export default EditTrucking;
